import { render, staticRenderFns } from "./HorizontalCartItem.vue?vue&type=template&id=400fd3fc&"
import script from "./HorizontalCartItem.vue?vue&type=script&lang=js&"
export * from "./HorizontalCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports